/**
 * 간단한 debounce 함수
 * 연속된 함수 호출을 제한하여 마지막 호출만 실행
 *
 * @param {Function} func - 실행할 함수
 * @param {number} delay - 지연 시간 (밀리초)
 * @returns {Function} - debounce된 함수
 */
export function debounce(func, delay) {
  let timeoutId;

  const debounced = function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };

  debounced.cancel = () => {
    clearTimeout(timeoutId);
    timeoutId = null;
  };

  return debounced;
}

/**
 * 즉시 실행 옵션이 있는 debounce 함수
 *
 * @param {Function} func - 실행할 함수
 * @param {number} delay - 지연 시간 (밀리초)
 * @param {boolean} immediate - 즉시 실행 여부
 * @returns {Function} - debounce된 함수
 */
export function debounceImmediate(func, delay, immediate = false) {
  let timeoutId;

  return function (...args) {
    const context = this;

    if (immediate && !timeoutId) {
      func.apply(context, args);
    }

    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      if (!immediate) {
        func.apply(context, args);
      }
      timeoutId = null;
    }, delay);
  };
}
